import React from 'react';
import LoyaltyCoupons from '../components/LoyaltyCoupons';
import { useBusinessStore } from '../store/useBusinessStore';

export default function LoyaltyPage() {
  const { masterDb, activeBusinessId, setMasterDb } = useBusinessStore();
  const activeBusiness = masterDb.find(b => String(b.id) === String(activeBusinessId));

  if (!activeBusiness) return <div>Cargando...</div>;

  const handleUpdateBusiness = (updatedBusiness) => {
    setMasterDb(prev => prev.map(b => {
      if (String(b.id) === String(updatedBusiness.id)) {
        return { ...b, ...updatedBusiness };
      }
      return b;
    }));
  };

  return (
    <LoyaltyCoupons
      activeBusiness={activeBusiness}
      onUpdateBusiness={handleUpdateBusiness}
    />
  );
}
